import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ClientBankAccountValidationService } from 'src/app/services/client-bank-account-validation.service';

@Component({
  // The input in the template is duplicated because one version is with autocomplete=off
  selector: 'terra-custom-field',
  template: `
    <label for="txt{{ fieldName }}" class="text-input-label">{{ fieldTitle }}</label>
    <mat-form-field appearance="outline">
      <input
        id="txt{{ fieldName }}"
        type="{{ type ? type : 'text' }}"
        autocomplete="{{ autocomplete === 'off' ? 'off' : 'on' }}"
        matInput
        [placeholder]="placeholder"
        [formControl]="control"
        [required]="requiredField"
        class="lo_sensitive"
      />
      <mat-error *ngIf="control.hasError('required')"> Required </mat-error>
      <mat-error *ngIf="control.hasError('pattern')">{{ patternErrorMessage }}</mat-error>
      <mat-error *ngIf="!!customError && control.hasError(customError)">{{customErrorMessage}}</mat-error>
    </mat-form-field>
  `
})
export class CustomFieldComponent implements OnInit {
  @Input() public requiredField: boolean;
  @Input() public fieldTitle: string;
  @Input() public fieldName: string;
  @Input() public placeholder: string;
  @Input() public control: UntypedFormControl;
  @Input() public type: string;
  @Input() public customError: string = '';
  @Input() public customErrorMessage: string = '';

  @Input() public autocomplete: string;

  public patternErrorMessage: string;
  constructor(private validationService: ClientBankAccountValidationService) {}

  ngOnInit(): void {
    this.control.valueChanges
      .subscribe(val => {
        if (val !== null && val !== undefined && val.length > 0) {
          this.patternErrorMessage = '';
          this.control.setErrors({ pattern: false });
          const validationResult = this.validationService.validateField(this.fieldName, val);
          if (
            validationResult !== null &&
            validationResult !== undefined &&
            validationResult.patterns !== null &&
            validationResult.patterns !== undefined &&
            validationResult.patterns.length > 0
          ) {
            this.patternErrorMessage = validationResult.patterns[0].errorMessage;
            this.control.setErrors({ pattern: true });
          } else {
            this.control.updateValueAndValidity({emitEvent: false});
          }
        } else {
          this.control.updateValueAndValidity({emitEvent: false});
        }
      });
  }
}
